import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { Badge } from "primereact/badge";
import { MultiSelect } from "primereact/multiselect";
import { InputMask } from 'primereact/inputmask';
import { MainButton } from "./Buttons";
import { AlignContent } from "./Cards";
import { ReactComponent as EditIcon } from "../assets/images/svg/pencil.svg"
import { ReactComponent as CreditCardIcon } from "../assets/images/svg/CreditCard.svg";
export function InputLayout({
  col,
  data,
  name,
  label,
  required,
  children,
  isRow = false,
  title,
}) {
  return (
    <div className={`${col ? col : "col-12"} ${isRow && "flex flex-wrap"}`}>
      <div className="md:col-4 col-12 p-0 pr-4">
        {title && <h4 className="m-0 p-0">{title}</h4>}
        {label && (
          <label htmlFor={name}>
            {label}
            {required && <span className="text-red-500">*</span>}
          </label>
        )}
      </div>
      <div className="col p-0">
        {children}
        {data?.formErrors && (
          <small className="text-red-500">{data?.formErrors[name]}</small>
        )}
      </div>
    </div>
  );
}

export function CustomInput({
  label,
  type,
  required,
  placeholder,
  onChange = () => null,
  value,
  data,
  name,
  col,
  extraClass = "",
  isRow,
  title,
  disabled,
  icon = "pi pi-default",
  iconAction,
  iconPos = "left",
  props,

}) {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}
    >
      <IconField iconPosition={iconPos}>
        {icon && <InputIcon className={`pi ${icon} ${iconAction && "cursor-pointer"}`} onClick={iconAction ? iconAction : null}> </InputIcon>}

        <InputText
          type={type ? type : "text"}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange({ name, value: e.target.value, e })}
          className={`w-full ${(!icon || icon === "pi pi-default") && "p-2"} mt-2 ${extraClass}`}
          disabled={disabled}
          {...props}
        />
      </IconField>
    </InputLayout>
  );
}

export function CustomInputNumber({
  label,
  type,
  required,
  placeholder,
  onChange = () => null,
  value,
  data,
  name,
  col,
  extraClass = "",
  isRow,
  title,
  disabled,
  icon,
  iconPos = "left",
  min,
  max,
}) {

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}
    >
      {/* <IconField iconPosition={iconPos}> */}
      {icon && <InputIcon className={`pi ${icon}`}> </InputIcon>}
      <InputNumber
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange({ name, value: e?.value, e })}
        className="w-full"
        inputClassName={`w-full ${!icon && "p-2"} mt-2 ${extraClass}`}
        disabled={disabled}
        min={min}
        max={max}
      />
      {/* </IconField> */}
    </InputLayout>
  );
}

export function CustomFloatInput({
  label,
  type,
  required,
  onChange,
  value,
  data,
  name,
  secondary,
  col,
  extraClass = "",
  disabled,
}) {
  return (
    <InputLayout col={col} name={name} data={data} required={required}>
      {" "}
      <FloatLabel>
        <InputText
          inputClassName="border-none"
          type={type ? type : "text"}
          name={name}
          value={value}
          onChange={(e) => onChange({ name, value: e.target.value, e })}
          className={`w-full border-none border-bottom-1 border-noround focus:shadow-none ${secondary && "bg-gray-200 border-1 border-gray-400 border-round p-2"
            } ${extraClass}`}
          disabled={disabled}
        />
        <label htmlFor={name}>{label}</label>
      </FloatLabel>
    </InputLayout>
  );
}

export function CustomPassword({
  label,
  required,
  placeholder,
  onChange,
  value,
  data,
  name,
  col,
  isFeedback = true,
  extraClass = "",
}) {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      data={data}
    >
      <Password
        toggleMask
        name={name}
        value={value || data?.name}
        placeholder={placeholder}
        feedback={isFeedback}
        onChange={(e) => onChange({ name, value: e.target.value, e })}
        className={`block ${extraClass}`}
        inputClassName={"w-full p-2 mt-2"}
      />
    </InputLayout>
  );
}

export function SingleCheckbox({
  label,
  required,
  name,
  checked,
  data,
  onChange,
}) {
  return (
    <div className="col">
      <div className="flex align-items-center">
        <Checkbox
          inputId={name}
          name={name}
          onChange={(e) => onChange({ name, value: e.checked })}
          checked={checked}
        />
        <label htmlFor={name} className="ml-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      </div>
      {data?.formErrors && (
        <small className="text-red-500">{data?.formErrors[name]}</small>
      )}
    </div>
  );
}

export function CustomDropDown({
  label,
  options,
  required,
  onChange,
  value,
  data,
  name,
  col,
  title,
  isRow,
  placeholder,
  extraClass = "",
  disabled,
}) {
  return (
    <InputLayout
      col={col}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}
      label={label}
    >
      <Dropdown
        value={value}
        onChange={(e) => {
          onChange({
            name,
            value: e?.value?.value ? e?.value?.value : e?.value,
            e,
          });
        }}
        options={options}
        optionLabel="name"
        className={`w-full ${extraClass}`}
        placeholder={placeholder}
        disabled={disabled}
      />
    </InputLayout>
  );
}

export function CustomMultiSelect({
  label,
  options,
  required,
  onChange,
  value,
  data,
  name,
  col,
  title,
  isRow,
  placeholder,
  extraClass = "",
  disabled,
}) {
  return (
    <InputLayout
      col={col}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}
      label={label}
    >
      <MultiSelect
        value={value}
        onChange={(e) => onChange({ name, value: e.value, e })}
        options={options}
        optionLabel="name"
        display="chip"
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full ${extraClass}`}
      />
    </InputLayout>
  );
}

export function CustomIconFeild({
  placeholder,
  value,
  onChange,
  icon = "pi pi-search",
  iconPos = "left",
  data,
  name,
  col,
  extraClass = "",
}) {
  return (
    <InputLayout col={col}>
      <IconField iconPosition={iconPos}>
        <InputIcon className={icon}> </InputIcon>
        <InputText
          placeholder={placeholder}
          onChange={(e) => onChange({ name, value: e.target.value, e })}
          className={`py-2 w-full ${extraClass}`}
        />
      </IconField>
    </InputLayout>
  );
}

export function CustomTextArea({
  label,
  placeholder,
  name,
  col,
  title,
  isRow,
  extraClass,
  value,
  onChange,
  data,
}) {
  return (
    <InputLayout
      col={col}
      name={name}
      data={data}
      isRow={isRow}
      title={title}
      label={label}
    >
      <InputTextarea
        autoResize
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange({ name, value: e.target.value, e })}
        rows={5}
        className={`w-full ${extraClass}`}
      />
    </InputLayout>
  );
}

export function CustomFileUpload({
  label,
  required,
  onChange,
  value,
  name,
  col,
  isRow,
  title,
  error,
  disabled = true,
  data,
  children,
}) {
  const toast = useRef(null);
  const [fileName, setFileName] = useState("");
  const [uploadStatus, setUploadStatus] = useState("pending"); // Track the status
  const [isUploading, setIsUploading] = useState(false);
  const [isBrowseDisabled, setIsBrowseDisabled] = useState(false); // Disable browse after upload

  const maxFileSize = 5 * 1024 * 1024; // 5MB size limit

  const customBase64Uploader = async (event) => {
    const file = event.files[0];

    // Set status to pending as soon as a new file is selected
    setUploadStatus("pending");

    // File type validation (ZIP only)
    if (file && file.type !== "application/zip") {
      toast.current.show({
        severity: "error",
        summary: "Invalid File",
        detail: "Please upload a valid ZIP file.",
      });
      setUploadStatus("failed");
      return;
    }

    // File size validation (5MB limit)
    if (file && file.size > maxFileSize) {
      toast.current.show({
        severity: "error",
        summary: "File Too Large",
        detail: "File size exceeds the 5MB limit.",
      });
      setUploadStatus("failed");
      return;
    }

    setIsUploading(true);
    setUploadStatus("pending");

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64File = reader.result.split(",")[1];
      onChange({ name, value: base64File });
      setFileName(file.name);
      setIsUploading(false);
      setIsBrowseDisabled(true); // Disable browse button after upload
      setUploadStatus("completed"); // Set status to completed after successful upload
      toast.current.show({
        severity: "success",
        summary: "File Uploaded",
        detail: "File successfully uploaded!",
      });
    };

    reader.onerror = () => {
      setIsUploading(false);
      setUploadStatus("failed"); // Set status to failed in case of an error
      setIsBrowseDisabled(true); // Disable browse button after failed upload
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error reading the file!",
      });
    };
  };

  const handleFileRemove = (props) => {
    setFileName(""); // Clear the file name
    setUploadStatus("pending"); // Reset the upload status
    setIsUploading(false); // Ensure that uploading is reset
    onChange({ name, value: "" }); // Clear the file in the parent component
    toast.current.show({
      severity: "info",
      summary: "File Removed",
      detail: "You can upload a new file.",
    });
  };

  const handleUpload = (event) => {
    // Called after the file upload is completed
  };

  // Format the file size in KB or MB
  const formatFileSize = (bytes) => {
    if (bytes === 0) {
      return "0 KB";
    }
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  // Function to capitalize the first letter of a string
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // Custom template for file items
  const itemTemplate = (file, props) => {
    // Capitalize status
    const capitalizedStatus = capitalizeFirstLetter(uploadStatus);

    return (
      <div className="" style={styles.fileRow}>
        {/* File Name and Size */}
        <div className="p-fileupload-filename">
          <strong>{file.name}</strong>
          <br />
          <small>{formatFileSize(file.size)}</small>
        </div>

        {/* Upload Status Badge */}
        <div className="p-fileupload-status" style={styles.statusBadge}>
          <Badge
            value={capitalizeFirstLetter(uploadStatus)} // Display the correct status
            severity={
              uploadStatus === "completed"
                ? "success"
                : uploadStatus === "failed"
                  ? "danger"
                  : "warning" // Default to warning for "pending"
            }
          />
        </div>

        {/* Cancel (Times) Button */}
        <button
          type="button"
          className="p-button p-component p-button-icon-only p-button-text p-button-rounded p-button-danger"
          style={{ marginLeft: "10px" }}
          // onClick={() => props.onRemove(file)}
          onClick={() => {
            props.onRemove(file); // Call the passed function to remove the file
            handleFileRemove(props); // Call your custom function to reset state
          }}
        >
          <i className="pi pi-times" style={{ fontSize: "1.2em" }}></i>
        </button>
      </div>
    );
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      data={value}
      required={required}
      isRow={isRow}
      title={title}
      disabled={disabled}
    >
      <Toast ref={toast} />
      <FileUpload
        name={name}
        accept=".zip"
        customUpload
        uploadHandler={customBase64Uploader}
        disabled={disabled || isUploading || !!fileName} // Disable the browse button if a file is uploaded
        emptyTemplate={
          <p className="m-0">Drag and drop a ZIP file here to upload.</p>
        }
        chooseLabel={isUploading ? "Uploading..." : "Browse"}
        onClear={handleFileRemove}
        onUpload={handleUpload}
        itemTemplate={itemTemplate}
      />
      <div className="col p-0">
        {children}
        {data?.formErrors && (
          <small className="text-red-500">{data?.formErrors[name]}</small>
        )}
      </div>
    </InputLayout>
  );
}

export function CustomSecret({
  label,
  type,
  required,
  placeholder,
  onChange = () => null,
  value,
  data,
  name,
  col,
  extraClass = "",
  isRow,
  title,
  disabled,
  icon,
  iconPos = "left",
  props,
}) {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}
    >
      <IconField >
        {icon && <InputIcon className={`pi  ${isVisible ? icon : 'pi pi-eye'}`} onClick={toggleVisibility}> </InputIcon>}
        <InputText
          type={isVisible ? "text" : "password"}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange({ name, value: e.target.value, e })}
          className={`w-full ${!icon && "p-2"} mt-2 ${extraClass}`}
          disabled={disabled}
          {...props}
        />
      </IconField>
    </InputLayout>
  );
}

// export function CustomCopyText({
//   label,
//   type,
//   required,
//   placeholder,
//   onChange = () => null,
//   value,
//   data,
//   name,
//   col,
//   extraClass = "",
//   isRow,
//   title,
//   disabled,
//   icon,
//   props,
// }) {
//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(value)
//   };

//   return (
//     <InputLayout
//       col={col}
//       label={label}
//       name={name}
//       data={data}
//       required={required}
//       isRow={isRow}
//       title={title}
//     >
//       <IconField>
//         {icon && <InputIcon className={`pi ${icon}`} onClick={copyToClipboard}><span>copy</span></InputIcon>}
//         <InputText
//           type={type ? type : "text"}
//           name={name}
//           value={value}
//           placeholder={placeholder}
//           onChange={(e) => {
//             onChange({ name, value: e.target.value, e })
//           }}
//           className={`w-full ${!icon && "p-2"} mt-2 ${extraClass}`}
//           disabled={disabled}
//           {...props}
//         />
//       </IconField>
//     </InputLayout>
//   );
// }

export function CustomCopyText({
  label,
  type,
  required,
  placeholder,
  onChange = () => null,
  value,
  data,
  name,
  col,
  extraClass = "",
  isRow,
  title,
  disabled,
  icon,
  props,
}) {
  const [userInput, setUserInput] = useState('');
  const copyToClipboard = () => {
    navigator.clipboard.writeText(value);
  };

  const handleChange = (e) => {
    const newValue = e.target.value.trim();
    setUserInput(e.target.value.trim());
    // const updatedRedirectUri = newValue 
    //   ? `https://${newValue}.pandastack.app/oauth2callback`
    //   : ""; 
    let updatedRedirectUri = "";

    if (newValue) {
      if (!newValue.startsWith("https://")) {
        updatedRedirectUri += "https://";
      }
      updatedRedirectUri += newValue;
      if (!newValue.endsWith(".pandastack.app/oauth2callback")) {
        updatedRedirectUri += ".pandastack.app/oauth2callback";
      }
    }
    onChange({ name, value: updatedRedirectUri, e });
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}
    >
      <IconField>
        {icon && <InputIcon className={`pi ${icon}`} onClick={copyToClipboard}><span>copy</span></InputIcon>}
        <InputText
          placeholder={placeholder}
          type={type ? type : "text"}
          name={name}
          value={userInput}
          onChange={handleChange}
          className={`w-full ${!icon && "p-2"} mt-2 ${extraClass}`}
          disabled={disabled}
          {...props}
        />
      </IconField>
    </InputLayout>
  );
}



export const CustomInputMask = ({
  id = "",
  label = "",
  extraClass = "",
  mask = "",
  placeholder = "",
  slotChar = "  ",
  bgCss = "",
  name,
  onChange = () => null,
}) => {
  const [userInput, setUserInput] = useState('');
  const handleChange = (e) => {
    const newValue = e.target.value.trim();
    setUserInput(e.target.value.trim());
    onChange({ name, value: newValue, e });
  };

  return (
    <div className={`expiry-date-input  ${extraClass} p-field`}>
      {label && (
        <label htmlFor={id} className="block font-medium mb-2">
          {label}
        </label>
      )}
      <InputMask
        id={id}
        name={name}
        value={userInput}
        onChange={handleChange}
        mask={mask}
        placeholder={placeholder}
        slotChar={slotChar}
        className={`p-inputtext w-full ${bgCss}`}
      />
    </div>
  );
};


// Styling
const styles = {
  fileRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 15px",
    borderBottom: "1px solid #ccc",
  },
  fileInfo: {
    flexGrow: 1,
  },
  statusBadge: {
    marginLeft: "15px",
  },
  cancelButton: {
    marginLeft: "15px",
  },
  expiryDateInput: {
    height: "45px",
    maxHeight: "45px",
    width: "100%",
  }
};

export const CustomCardInput = ({
  cardNumber = '1234 **** ****',
  onClick = "",
  editButtonLabel = 'Edit',
  editButtonIcon = <EditIcon />,
  extraClass = '',
  cardIcon = <CreditCardIcon />,
}) => {
  return (
    <div className="col-12 sm:col-12 md:col-8 lg:col-8 xl:col-8 p-0">
      <div className="border-1 border-round-sm border-gray-300 bg-gray-100 flex align-center justify-content-between gap-2 text-gray-400 mt-3 mb-3 p-2">
        <div className="align-center">
          {cardIcon}
          <span>{cardNumber}</span>
        </div>
        <AlignContent horizontal="end">
          <MainButton
            label={editButtonLabel}
            icon={() => editButtonIcon}
            textOnly
            extraClass={`text-gray-400 py-0 ${extraClass}`}
            onClick={onClick}
          />
        </AlignContent>
      </div>
    </div>
  );
};

export const CustomInputTitleOnly = ({
  title = "Billing Address",
  description = "You will be charged for usage beyond your free limits. View pricing.",
  onEditClick,
  buttonLabel = "Edit",
  buttonIcon = <EditIcon />,
  extraClass = "",
}) => {
  return (
    <div className={`col-12 flex flex-wrap w-full pt-2 mt-1 mb-3 align-center ${extraClass}`}>
      <div className="md:col-6 col-6 p-0 block">
        <h4 className="m-0 p-0">{title}</h4>
        <label>{description}</label>
      </div>
      <div className="md:col-6 col-6 p-0">
        <AlignContent horizontal="end">
          <MainButton
            label={buttonLabel}
            icon={() => buttonIcon}
            textOnly
            extraClass="text-gray-400 py-0"
            onClick={onEditClick}
          />
        </AlignContent>
      </div>
    </div>
  );
};

export const CustomCreditIconInput = ({
  label,
  type,
  required,
  placeholder,
  onChange = () => null,
  value,
  data,
  name,
  col,
  extraClass = "",
  isRow,
  title,
  disabled,
  icon = <CreditCardIcon />,
  iconAction,
  iconPos = "right",
  props,
  mask
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      data={data}
      required={required}
      isRow={isRow}
      title={title}>
      <IconField iconPosition={iconPos}>
        <InputText
          type={type ? type : "text"}
          name={name}
          value={value}
          mask={mask}
          placeholder={placeholder}
          onChange={(e) => onChange({ name, value: e.target.value, e })}
          className={`w-full ${(!icon || icon === "pi pi-default") && "p-2"} mt-2 ${extraClass}`}
          disabled={disabled}
          {...props}
        />
        {icon && <InputIcon className={`pi ${icon} ${iconAction && "cursor-pointer"}`} onClick={iconAction ? iconAction : null}> {icon}</InputIcon>}
      </IconField>
    </InputLayout>
  );
}

export const CustomCardMask = ({
  id = "",
  label = "",
  extraClass = "",
  mask = "",
  placeholder,
  slotChar = "  ",
  bgCss = "",
  iconPos,
  icon,
  iconAction
}) => {
  <div className={`expiry-date-input  ${extraClass} p-field`}>
    {label && (
      <label htmlFor={id} className="block font-medium mb-2">
        {label}
      </label>
    )}
    <IconField iconPosition={iconPos}>
      <InputMask
        id={id}
        mask={mask}
        placeholder={placeholder}
        slotChar={slotChar}
        className={`p-inputtext w-full ${bgCss}`}
      />
      {icon && <InputIcon className={`pi ${icon} ${iconAction && "cursor-pointer"}`} onClick={iconAction ? iconAction : null}> {icon}</InputIcon>}
    </IconField>
  </div>
}
